$('.rating-send__item input').click(function() {
    
    // get all prev siblings of this
    $(this).parent().prevAll().css('--rckryd-icon-color', '#FFC876');
    $(this).parent().css('--rckryd-icon-color', '#FFC876');
    $(this).parent().nextAll().css('--rckryd-icon-color', '#d7d7d7');

    $('.rating-send__num').addClass('text-warning').removeClass('text-base-light-30').text($(this).val());
});